import { Dictionary } from "lodash";
import { useState } from "react";

export default function useAutoAdder() {
  const [adder] = useState(new AutoAdder());

  return adder;
}

export type AutoAdderRegister = (
  code: string,
  operation: () => boolean,
) => void;

export class AutoAdder {
  private operations: Dictionary<() => boolean> = {};

  registerOperation = (code: string, operation: () => boolean) => {
    this.operations[code] = operation;
  };

  checkAutoAdd = (): boolean => {
    const results = Object.keys(this.operations).map(e => this.operations[e]());

    if (results.filter(e => !e).length > 0) {
      return false;
    }

    return true;
  };
}
